import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { User } from '../../models/user.model'
import { Subscription } from 'rxjs';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import { MatDialog } from '@angular/material/dialog';
//import { UserRegisterComponent } from './user-register/user-register.component';
import { LocalStorageService } from '../services/localStorage-service/local-storage.service';
import { UserDashboardService } from '../user-dashboard.service';
import {environment} from '../../../environments/environment.prod';

@Component({
    selector: 'landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {

  private user: User

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;
  imageUrl
  header

  constructor(private router: Router, private languageService: UserLanguageService,
    public dialog: MatDialog,
    dashboardService: UserDashboardService,
    private localStorageService: LocalStorageService) {
    this.languageService.setLanguage(this.localStorageService.getItem('lang') ?? 'cirilica');
  }
  position
  ngOnInit(): void {

    this.localStorageService.clear()
    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
      switch (lang) {
        case 'eng':
          this.imageUrl = environment.loginImagePath1;
          break;
        case 'srb':
          this.imageUrl = environment.loginImagePath2;
          break;
        default:
          this.imageUrl = environment.loginImagePath3;
      }
    })
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    this.header = this.labels.lblLearning

  }
  ngOnDestroy(): void {

  }

  goToLogin(){
  }

  goToRegistration() {

  }
  selectLang(lang) {
    this.languageService.setLanguage(lang);
  }

}
